import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegistrationSuccess = () => {
  const location = useLocation();
  const { email, name } = location.state || {};

  return (
    <div className="min-h-screen bg-gray-50">

      <div className=" flex flex-col justify-center py-12 sm:px-6 lg:px-8">

        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <Icon name="CheckCircle" size={32} color="#059669" />
          </div>
        </div>

        {/* Success Message */}
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Welcome to C-success recruit!
          </h2>

          {name && (
            <p className="text-lg text-gray-700 mb-2">
              Hi {name}! 👋
            </p>
          )}

          <p className="text-gray-600 mb-6">
            Your candidate account has been successfully created.
            {email && (
              <span className="block mt-2 text-sm">
                A confirmation email has been sent to{' '}
                <span className="font-medium text-gray-900">{email}</span>
              </span>
            )}
          </p>

          {/* Next Steps */}
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <h3 className="text-sm font-medium text-blue-900 mb-2">
              What's next?
            </h3>
            <ul className="text-sm text-blue-700 space-y-1 text-left">
              <li className="flex items-start">
                <Icon name="ArrowRight" size={16} color="#1d4ed8" className="mt-0.5 mr-2 flex-shrink-0" />
                Browse and apply for jobs that match your skills
              </li>
              <li className="flex items-start">
                <Icon name="ArrowRight" size={16} color="#1d4ed8" className="mt-0.5 mr-2 flex-shrink-0" />
                Upload your CV for AI-powered job matching
              </li>
              <li className="flex items-start">
                <Icon name="ArrowRight" size={16} color="#1d4ed8" className="mt-0.5 mr-2 flex-shrink-0" />
                Track your application status online
              </li>
              <li className="flex items-start">
                <Icon name="ArrowRight" size={16} color="#1d4ed8" className="mt-0.5 mr-2 flex-shrink-0" />
                Get notified about interview opportunities
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <Link to="/public/jobs" className="block">
              <Button className="w-full" variant="default">
                <Icon name="Search" size={20} className="mr-2" />
                Browse Available Jobs
              </Button>
            </Link>

            <Link to="/public/login" className="block">
              <Button className="w-full" variant="outline">
                <Icon name="LogIn" size={20} className="mr-2" />
                Sign In to Your Account
              </Button>
            </Link>
          </div>

          {/* Additional Information */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <h4 className="text-sm font-medium text-gray-900 mb-2">
              Need help getting started?
            </h4>
            <div className="text-sm text-gray-600 space-y-1">
              <p>
                <Icon name="Mail" size={14} className="inline mr-1" />
                Email us at{' '}
                <a href="mailto:info@c-successconsulting.com" className="text-blue-600 hover:text-blue-500">
                  info@c-successconsulting.com
                </a>
              </p>
              <p>
                <Icon name="Phone" size={14} className="inline mr-1" />
                Call us at{' '}
                <a href="tel:+265888207714" className="text-blue-600 hover:text-blue-500">
                  +265 888 207 714
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <div className="mt-8 text-center">
        <p className="text-xs text-gray-500 max-w-md mx-auto">
          Your account gives you access to our job portal and application tracking system.
          Our AI-powered matching system will help you find the perfect career opportunities.
        </p>
      </div>

    </div>





  );
};

export default RegistrationSuccess;